import {FormTextField} from "../shared/FormTextField";
import * as React from "react";
import {Divider, Grid, Typography} from "@mui/material";
import {IngredientGroupForm} from "../shared/IngredientGroupForm";
import {IngredientCollectionForm} from "../shared/IngredientCollectionForm";
import {
  ingredientTypeGrain,
  ingredientTypeInclusion,
  ingredientTypeLiquid,
  SUBMIX_TYPE_PORRIDGE,
  SUBMIX_TYPE_SCALD
} from "../shared/Types";
import {DecimalFormField} from "../shared/DecimalFormField";

function SubMix(props) {
  const {subMixData, updateSubMixData, updateIngredientList, componentId} = props

  function onStringFieldChange(evt) {
    updateSubMixData({...subMixData, [evt.target.name]: evt.target.value});
  }

  function onDecimalChange(fieldName, fieldValue) {
    updateSubMixData({...subMixData, [fieldName]: fieldValue})
  }

  function onFlourChange(flourData) {
    updateSubMixData({...subMixData, flour: flourData});
  }

  function onGrainChange(grainData) {
    updateSubMixData({...subMixData, grain: grainData});
  }

  function onDryChange(dryData) {
    updateSubMixData({...subMixData, dry: dryData});
  }

  function onLiquidChange(liquidData) {
    updateSubMixData({...subMixData, liquid: liquidData});
  }

  function renderPorridgeSubMix() {
    // temporary: handle pre-existing formula with obsolete 'reducePct' and no persisted absorbPct
    if (! Object.hasOwn(subMixData, 'absorbPct') && Object.hasOwn(subMixData, 'reducePct')) {
      subMixData['absorbPct'] = subMixData['reducePct']
    }
    return (
            <div>
              <Grid marginLeft={-1} marginRight={-1} item>
                <DecimalFormField disabled={false} label={'Dry Absorb %'} variant={'outlined'} size={'small'}
                                  value={subMixData.absorbPct} sx={{marginLeft: 1, width: '12ch'}}
                                  name={'absorbPct'} minVal={0} maxVal={999} onChange={onDecimalChange}/>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Grain</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <IngredientGroupForm ingredientData={subMixData.grain} setIngredientData={onGrainChange}
                                       balanceGoal={100} idField={'id'} nameField={'name'}
                                       unitField={'percent'} groupName={'Grain'} minGroupSize={1} disabled={false}
                                       ingredientType={ingredientTypeGrain} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Dry Ingredients</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <IngredientCollectionForm ingredientData={subMixData.dry} setIngredientData={onDryChange}
                                            idField={'id'} nameField={'name'} unitField={'percent'} collectionName={'Dry'}
                                            ingredientType={ingredientTypeInclusion} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <IngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange}
                                            idField={'id'} nameField={'name'} unitField={'percent'} collectionName={'Liquid'}
                                            ingredientType={ingredientTypeLiquid} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  function renderScaldSubMix() {
    return (
            <div>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Flour</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <IngredientGroupForm ingredientData={subMixData.flour} setIngredientData={onFlourChange}
                                       balanceGoal={100} idField={'id'} nameField={'name'}
                                       unitField={'percent'} groupName={'Flour'} minGroupSize={1} disabled={false}
                                       ingredientType={ingredientTypeGrain} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'}>
                  <IngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange}
                                            idField={'id'} nameField={'name'} unitField={'percent'} collectionName={'Liquid'}
                                            ingredientType={ingredientTypeLiquid} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  function renderSoakerSubMix() {
    // temporary: handle pre-existing formula with obsolete 'reducePct' and no persisted absorbPct
    if (! Object.hasOwn(subMixData, 'absorbPct') && Object.hasOwn(subMixData, 'reducePct')) {
      subMixData['absorbPct'] = subMixData['reducePct']
    }
    return (
            <div>
              <Grid marginLeft={-1} marginRight={-1} item>
                <DecimalFormField disabled={false} label={'Dry Absorb %'} variant={'outlined'} size={'small'}
                                  value={subMixData.absorbPct} sx={{marginLeft: 1, width: '12ch'}}
                                  name={'absorbPct'} minVal={0} maxVal={999} onChange={onDecimalChange}/>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Dry Ingredients</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'} >
                  <IngredientGroupForm ingredientData={subMixData.dry} setIngredientData={onDryChange}
                                       balanceGoal={100} idField={'id'} nameField={'name'}
                                       unitField={'percent'} groupName={'Dry'} minGroupSize={1} disabled={false}
                                       ingredientType={ingredientTypeInclusion} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
              <Grid item>
                <Divider textAlign={'right'} sx={{marginTop: 1.5, width: '100%'}}>
                  <Typography sx={{fontSize: 12, fontWeight: 350}}>Liquid</Typography>
                </Divider>
                <Grid item container direction={'column'} alignItems={'flex-start'} >
                  <IngredientCollectionForm ingredientData={subMixData.liquid} setIngredientData={onLiquidChange} idField={'id'}
                                            nameField={'name'} unitField={'percent'} collectionName={'Liquid'}
                                            ingredientType={ingredientTypeLiquid} updateIngredientList={updateIngredientList} componentId={componentId}/>
                </Grid>
              </Grid>
            </div>
    )
  }

  return (
    <div>
      <Grid item container marginLeft={-1} marginRight={-1} direction={'column'} justifyContent={'center'}>
        <Grid item container direction={'row'}>
          <FormTextField size={'small'}
                         sx={{width: '19ch'}}
                         id="submix-name"
                         label={'Name'}
                         name={'name'}
                         value={subMixData.name}
                         onChange={(evt) => onStringFieldChange(evt)}/>
          <DecimalFormField disabled={false} label={'% Main'} variant={'outlined'} size={'small'}
                            value={subMixData.mainPct} sx={{marginLeft: 1, width: '7ch'}}
                            name={'mainPct'} minVal={0.1} maxVal={99} onChange={onDecimalChange}/>
        </Grid>
        <Grid item alignItems={'flex-start'} marginTop={1} marginBottom={1}>
          <FormTextField  sx={{marginTop: 1, marginBottom: 1.5}} multiline rows={3}
                          size={'small'} fullWidth
                          id={'notes'}
                          placeholder={'Notes'}
                          variant={'outlined'}
                          label={'Notes'}
                          name={`notes`}
                          value={subMixData.notes || ''}
                          onChange={(evt) => onStringFieldChange(evt)}/>
        </Grid>
        {subMixData.type === SUBMIX_TYPE_PORRIDGE ? renderPorridgeSubMix()
                : (subMixData.type === SUBMIX_TYPE_SCALD ? renderScaldSubMix() : renderSoakerSubMix())}
      </Grid>
    </div>
  )
}

export {SubMix}
